let validatePass = (rule, value, callback)=>{
  let reg = /^((((?!0)\d+)|(0{1}))(.\d{1,2})?)$/
  if (value === '') {
    callback(new Error('请输入单价'));
  } else if (value == 0){
    callback(new Error('单价不能为0'));
  } else if (String(value).search(reg) < 0) {
    callback(new Error('单价格式有误,只允许输入数字，支持两位小数'));
  } else {
    callback();
  }
};
let validateTextPass = (rule, value, callback,text,length,c)=>{
  let reg = /.*[\u4e00-\u9fa5]+.*$/;
  if (value === '') {
    callback(new Error('请输入'+text));
  } else if (c && reg.test(value)) {
    callback(new Error('不能输入中文'))
  } else if (String(value).length > length) {
    callback(new Error('长度限制' + length + '字'));
  } else {
    callback();
  }
};
export const tableOption = {
  border: true,
  index: true,
  indexLabel: '序号',
  delBtn:false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menuWidth:400,
  refreshBtn: true,
  searchMenuSpan: 6,
  addBtnText:'新增引擎',
  addTitle:'新增引擎',
  showClomnuBtn: false,
  searchSize: 'mini',
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [
    {
    label: '主键ID',
    prop: 'id',
    row: true,
    addDisplay:false,
    editDisabled:true,
    rules: [{
      required: true,
      message: "请输入引擎ID",
      trigger: "blur"
    }],
    span: 24
  }, {
      label: '引擎ID',
      prop: 'code',
      row: true,
      // hide: true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '引擎code', 200,true);
        }),
        trigger: 'blur'
      }],
      span: 24
    }, {
      label: '行业ID',
      prop: 'industry',
      row: true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '行业code', 200,true);
        }),
        trigger: 'blur'
      }],
      span: 24
    },{
      label: '行业名称',
      prop: 'industryName',
      overHidden: true,
      span: 24,
      type: 'select',
      dicUrl: '/system/dict/type/industry_name',
      rules: [{
        required: true,
        message: '请选择行业名称',
        trigger: 'blur'
      }]
    },
    {
    label: '引擎名称',
    prop: 'name',
    searchSpan: 4,
      // searchLabelWidth: 110,
    span: 24,
    row: true,
    rules: [{
      required: true,
      validator: ((rule, value, callback) => {
        validateTextPass(rule, value, callback, '引擎名称', 100);
      }),
      trigger: 'blur'
    }],
    search: true,
    editDisplay: true,
  }, {
      label: '简称',
      prop: 'shortName',
      searchSpan: 4,
      // searchLabelWidth: 110,
      span: 24,
      row: true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '简称', 100);
        }),
        trigger: 'blur'
      }],
      search: true,
      editDisplay: true,
    },{
      label: '适用场景',
      prop: 'intro',
      span: 24,
      row: true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '适用场景', 100);
        }),
        trigger: 'blur'
      }],
      editDisplay: true,
    },{
      label: '成本单价(千字/词)',
      labelWidth: 140,
      searchLabelWidth:140,
      prop: 'price',
      searchSpan: 6,
      span: 24,
      rules: [{
        required: true,
        validator: validatePass,
      }],
      row: true,
      editDisplay: true,
      search: true,
    },{
      label: '提供者',
      searchSpan: 4,
      prop: 'creator',
      // type:'select',
      // filterable: true,
      // allowCreate:true,
      formslot: false,
      // dicData: [],
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '提供者', 50);
        }),
        trigger: 'blur'
      }],
      span: 24,
      row: true,
      editDisplay: true,
      search: true,
    },{
      label: '维护者',
      span: 24,
      // filterable: true,
      // allowCreate:true,
      // type:'select',
      prop: 'maintainer',
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '维护者', 50);
        }),
        trigger: 'blur'
      }],
      row: true,
      editDisplay: true,
    },{
      label: '同步PM端接口地址',
      labelWidth: 150,
      span: 24,
      prop: 'sync1Url',
      hide:true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '同步PM端接口地址', 200, true);
        }),
        trigger: 'blur'
      }],
      row: true,
      editDisplay: true,
    },{
      label: '同步新语翼接口地址',
      labelWidth: 160,
      span: 24,
      prop: 'sync2Url',
      hide:true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '同步新语翼接口地址', 200,true);
        }),
        trigger: 'blur'
      }],
      row: true,
      editDisplay: true,
    },{
      label: '版权所有',
      labelWidth: 100,
      span: 24,
      prop: 'copyright',
      hide:true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '版权所有', 200);
        }),
        trigger: 'blur'
      }],
      row: true,
      editDisplay: true,
    },{
      label: '适用稿件',
      labelWidth: 100,
      span: 24,
      prop: 'files',
      hide:true,
      rules: [{
        required: true,
        validator: ((rule, value, callback) => {
          validateTextPass(rule, value, callback, '适用稿件', 200);
        }),
        trigger: 'blur'
      }],
      row: true,
      editDisplay: true,
    },{
    label: '状态',
    searchSpan: 4,
    width: 140,
    prop: 'status',
      type: 'switch',
      activeColor:'#ff4949',
      inactiveColor:'#13ce66',
      search: true,
      rules: [{
        required: true,
        message: "请选择状态",
        trigger: "blur"
      }],
      value:1,
      dicData: [{
        label: '启用',
        value: 1
      }, {
        label: '禁用',
        value: 0
      }],
    editDisplay: true,
    formslot: true
  }]
}
